export const Bio = {
  name: "Puneet Yadav",
  roles: [
    "Web Developer",
    "Open Source Contributor",
  ],
  description:
    "I’m a Web Developer and Open Source Contributor with a strong focus on Data Structures & Algorithms. I enjoy building practical solutions, contributing to community-driven projects, and continuously improving my skills through learning and experimentation.",
  resume:
    "https://drive.google.com/file/d/1ODFWKqZND4Mh0JQfhnHXzjqlH7ImhAVH/view?usp=sharing",
  linkedin:
    "https://www.linkedin.com/in/puneet-yadav-541166325?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app/",
  insta: "https://www.instagram.com/puneetyadav1625?igsh=MWk5d2ViMTA3YWt1bg==/",
  github: "https://github.com/puneetnith28",
};

export const skills = [
  {
    title: "Technical",
    skills: [
      {
        name: "C++",
        image:
          "https://i.ibb.co/dsqxZ1bY/C.png",
      },
      {
        name: "Node Js",
        image:
          "https://i.ibb.co/3ykmRmpM/node-JS.png",
      },
      {
        name: "Express Js",
        image:
          "https://i.ibb.co/nN2WcBVw/express-js1.webp",
      },
      {
        name: "React Js",
        image:
          "https://i.ibb.co/svx6NTNG/React.webp",
      },
      {
        name: "JavaScript",
        image:
          "https://i.ibb.co/ycJpKhZ0/javascript.webp",
      },
      {
        name: "HTML",
        image: "https://i.ibb.co/1tTWQcn5/htm.webp",
      },
      {
        name: "CSS",
        image:
          "https://i.ibb.co/3YPcFPJ1/css3.png",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "MongoDB",
        image:
          "https://i.ibb.co/1GzHmMY9/Mongodb.png",
      },
      {
        name: "Git",
        image:
          "https://i.ibb.co/Hf4dQDrQ/git.png",
      },
      {
        name: "GitHub",
        image:
          "https://i.ibb.co/5xgWfCk1/github1.webp",
      },
      {
        name: "Canva",
        image:
          "https://i.ibb.co/ynJTtMLT/canva-logo.png",
      },
      {
        name: "Netlify",
        image:
          "https://i.ibb.co/wh1B6vhD/netlify.png",
      },
      {
        name: "Vercel",
        image:
          "https://i.ibb.co/WbQ9QfQ/Vercel.webp",
      },
      {
        name: "Render",
        image:
          "https://i.ibb.co/XrG1q01w/render-logo.png",
      },
      {
        name: "Figma",
        image:
          "https://i.ibb.co/B5QfS7kt/figma.webp",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://i.ibb.co/6R5hVZd3/images-2.jpg",
    role: "Contributor",
    company: "Social Winter of Code",
    date: "Jan 2026 - Feb 2026",
    desc: "Merged 7 pull requests across multiple repositories, with key contributions to the BrowsePing Chrome Extension. Focused on feature development, bug fixes, and code quality improvements.",
    skills: ["Open Source Contribution", "Networking", "Collaboration"],
  },
  {
    id: 0,
    img: "https://i.ibb.co/CK1SPkBP/images-1.jpg",
    role: "Super Contributor",
    company: "HacktoberFest",
    date: "Oct 2025 - Oct 2025",
    desc: "Delivered 8 merged pull requests to AlgoVisualizer, contributing to algorithm visualizations, UI improvements, and bug fixes using React, JavaScript, Git, and GitHub.",
    skills: ["Open Source Contribution", "Networking", "Collaboration"],
  },
  {
    id: 1,
    img: "https://i.ibb.co/gMPpFG3m/gdsc1.png",
    role: "Executive Member",
    company: "GDG Ludhiana-NIT Hamirpur Chapter",
    date: "Aug 2025 - Present",
    desc: "Played an active role in organizing and managing events, coordinating with team members and speakers, and driving initiatives that strengthened community engagement.",
    skills: ["Open Source Contribution", "Event Management"],
  },
  {
    id: 3,
    img: "https://i.ibb.co/bMdchqfz/Reliance.jpg",
    role: "Scholar",
    company: "Reliance Foundation",
    date: "Jan 2025 - Present",
    desc: "Being a Reliance Foundation Scholar has provided mentorship, structured learning resources, and exposure to a strong peer and industry network. The program has supported continuous learning and overall professional growth.",
    skills: ["Side Hustle Management", "Professional Networking"],
  },
];

export const volunteerExperiences = [
  {
    id: 0,
    img: "https://i.ibb.co/gMPpFG3m/gdsc1.png",
    role: "Volunteer",
    company: "GDG Ludhiana-NIT Hamirpur Chapter",
    date: "Jan 2025 - Aug 2025",
    desc: "Actively engaged in workshops, tech sessions, and projects, learning new technologies and collaborating with a developer community. ",
    skills: ["JavaScript", "React Js", "Figma", "Teamwork", "Networking"],
  },
  {
    id: 1,
    img: "https://i.ibb.co/1YQN08xT/Bharat-Scout-Guide.jpg",
    role: "Student Volunteer ",
    company: "The Bharat Scout & Guides",
    date: "Sep 2016 - Aug 2019",
    desc: "Actively contributed to community service and leadership in the Scouts and Guides program, gaining experience in teamwork, problem-solving, and organization while leading social initiatives and promoting a spirit of service.",
    skills: ["Discipline", "Leadership", "Teamwork"],
  },
];

export const education = [
  {
    id: 0,
    img: "https://i.ibb.co/NdXfZX5B/n-i-t-hamirpur-logo-k9i9rshtvwz2dvm5.png",
    school: "National Institute of Technology, Hamirpur",
    date: "Aug 2024 - May 2028",
    grade: "8 CGPA",
    desc: "I'm pursuing a B.Tech in CSE at NIT Hamirpur, focusing on core subjects like Data Structures & Algorithms, and Web Development. Alongside academics, I actively participate in hackathons, coding events and other related events to build real-world skills.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://i.ibb.co/Dgr4HGd8/WNxso-R8a-400x400.jpg",
    school: "Jawahar Navodaya Vidyalaya, Sant Kabir Nagar",
    date: "Apr 2022 - Mar 2023",
    grade: "93.4%",
    desc: "I completed my class 12th school education at Jawahar Navodaya Vidyalaya, Sant Kabir Nagar, where I studied Science with Hindi. These years strengthened my academic foundation and nurtured my interest in learning, setting the stage for my journey into engineering and technology.",
    degree: "CBSE(XII)",
  },
  {
    id: 2,
    img: "https://i.ibb.co/Dgr4HGd8/WNxso-R8a-400x400.jpg",
    school: "Jawahar Navodaya Vidyalaya, Sant Kabir Nagar",
    date: "Apr 2020 - Mar 2021",
    grade: "90.8%",
    desc: "I completed my Class 10th from Jawahar Navodaya Vidyalaya, Sant Kabir Nagar. My school years played a crucial role in shaping my discipline, work ethic, and problem-solving mindset—skills that continue to support my academic and personal growth.",
    degree: "CBSE(X)",
  },
];

export const certificates = [
  {
    id: 0,
    title: "Hack 5.0",
    date: "Apr 2025",
    image: "https://i.ibb.co/r23hvqKS/certi.jpg",
    category: "participation",
    link: "https://drive.google.com/file/d/1xZJmUUpSGYICy1rhknnzBPRGgU2vwX3N/view",
  },
];

export const projects = [
  {
    id: 0,
    title: "Rework",
    description:
      "A Git-style version control concept for creative workflows, featuring a frontend prototype with dashboards and version comparisons. Simulated real workflows using mock data and AI summaries, with planned integrations for tools like Figma, Docs, and Canva.",
    image:
      "https://i.ibb.co/prB4VpxC/localhost-5173-3.png",
    category: "web app",
    github: "https://github.com/puneetnith28/Rework",
    liveLink: "https://github.com/puneetnith28/Rework",
  },
  {
    id: 1,
    title: "ChatApp",
    description: "A full-stack real-time chat application built using the MERN stack, featuring instant messaging powered by Socket.io. The application includes secure JWT-based authentication, persistent chat storage with MongoDB, and an integrated AI assistant using Google Gemini for context-aware responses. Designed to deliver a seamless and interactive communication experience.",
    image: "https://i.ibb.co/pj6z5FTx/chat-app-2026.png",
    category: "web app",
    github: "https://github.com/puneetnith28/ChatApp",
    liveLink: "https://chat-app-2026.vercel.app/"
  },
  {
    id: 2,
    title: "Authentication System",
    description:
      "A secure authentication system built with Node.js, Express, and MongoDB, featuring user registration, login, password hashing, and JWT-based session management. It provides a robust foundation for user authentication in web applications.",
    image:
      "https://i.ibb.co/SXQPZzk5/localhost-5173-4.png",
    category: "web app",
    github: "https://github.com/puneetnith28/Authentication-System",
    liveLink: "https://github.com/puneetnith28/Authentication-System",
  },
  {
    id: 4,
    title: "Portfolio",
    description:
      "A personal portfolio website developed while learning React.js to present my skills, projects, experience and all. It features a clean, responsive design with smooth navigation and interactive components. Building this project helped me grasp core React concepts like components, props, state, and many things.",
    image:
      "https://i.ibb.co/35nH2rJ5/localhost-3000-1.png",
    category: "web app",
    github: "https://github.com/puneetnith28/Portfolio-Website",
    liveLink: "https://puneetyportfolio.netlify.app/",
  },
];

export const blogs = [
  {
    id: 0,
    title: "Understanding the Bitcoin Mempool",
    description:
      "A comprehensive guide to understanding the Bitcoin mempool, its role in transaction processing, and how it affects transaction confirmation times. This blog provides insights into the inner workings of the mempool and its impact on the Bitcoin network.",
    image: "https://i.ibb.co/PZWVWJ07/photomempool.avif",
    link: "https://medium.com/@puneetjnv28/8900393f9a5d",
    date: "Feb 12, 2026",
    tags: ["mempool"],
  },
  {
    id: 1,
    title: "How Does a Bitcoin Transaction Actually Work?",
    description:
      "A deep dive into the mechanics of Bitcoin transactions, explaining how they are created, validated, and recorded on the blockchain. This blog breaks down complex concepts into simple terms, making it accessible for anyone interested in understanding how Bitcoin works under the hood.",
    image: "https://i.ibb.co/5h6SQMnr/bitcoin.jpg",
    link: "https://medium.com/@puneetjnv28/how-does-a-bitcoin-transaction-actually-work-58ee82edb223",
    date: "Feb 11, 2026",
    tags: [ "Bitcoin"],
  },
  {
    id: 2,
    title: "What I Learned Contributing to Open Source Projects",
    description:
      "In this blog, I share my experiences and key takeaways from contributing to open source projects, including the challenges I faced, the skills I developed, and the impact it had on my growth as a developer.",
    image: "https://i.ibb.co/MDPD8v71/oss.jpg",
    link: "https://medium.com/@puneetjnv28/what-i-learned-contributing-to-open-source-projects-44d48116fdce",
    date: "Feb 10, 2026",
    tags: ["Open Source"],
  },
];

